<template>
  <div class="bg">
    <!-- {{msg}} -->
  </div>
</template>

<script>
import Lib from "../lib/lib.js";
import {mapState} from "vuex";
import { Loading } from "element-ui";

export default {
  name: "logo",
  data() {
    return {
      msg: "",
      type:this.$route.query.type
    };
  },
    computed:{...
        mapState({
            isMobile:state=>state.isMobile
        })
    },
  created() {
    this.verifyToken();
    this.$store.dispatch('setDeviceListType',this.type)
  },
  methods: {
    verifyToken() {
      let query = this.$route.query;
      let userInfo = Lib.M.ls.getItem("userInfo"),
        customer_token = query.customer_token,
        user_token = query.user_token;
      if (!customer_token && !user_token && userInfo) {
        if (userInfo.identity === "CUSTOMER") {
          customer_token = userInfo.token;
        }
        // else if (userInfo.identity === "USER") {
        //       user_token = userInfo.token;
        //   }

      }

      if (customer_token) {
        this.verifyCustom(customer_token);
      } else if (user_token) {
        this.verifyUser(user_token);
      } else {
        this.msg = "登陆失败";
        // 登陆失败 返回登陆页

        location.href = Lib.C.adminHost + "leemmaCustomer?state="+this.type;

      }
    },
    verifyCustom(customer_token) {
      Lib.api.verifyCustom({ customer_token: customer_token }, data => {
        if (data.status_code === "SUCCEEDED") {
          let payload = {
            token: customer_token,
            identity: "CUSTOMER",
            ...data.payload
          };
          this.$store.dispatch("setUserInfo", payload);
            this.$router.push("/user/");

        } else {
          this.$router.push("/error");
        }
      });
    },
    verifyUser(token) {
      Lib.api.verifyUser({ auth_token: token }, data => {
        if (data.status_code === "SUCCEEDED") {
          let payload = {
            token: token,
            identity: "USER",
            ...data.payload
          };
          this.$store.dispatch("setUserInfo", payload);
          this.loadDevice(token);
        } else {
          // 检测token失败，判断是否是微信
          // this.$router.push("/error?error=401");
          if(Lib.M.isWeChat()){
            console.log("wechat")
          }else{
            console.log("customer")

          }
          // location.href = Lib.C.adminHost + "leemmaWechatLogin";
          // location.href = Lib.C.adminHost + "leemmaCustomer";
        }
      });
    },
    loadDevice(token) {
      let deviceInfo = Lib.M.ls.getItem("deviceInfo");
      let params = {
        device_id: this.$route.query.device_id
          ? this.$route.query.device_id
          : deviceInfo.device_id,
        auth_token: token
      };
      Lib.api.loadDevice(params, data => {
        if (data.status_code === "SUCCEEDED") {
          this.$store.dispatch("setDeviceInfo", data.payload);
          if(data.payload.category==='温控'){
              if(this.isMobile){
                  this.$router.push("/MtempControl/");

              }else{
                  this.$router.push("/tempControl/");

              }

          }else{
                  this.$router.push("/allocate/");
          }
        } else {
            this.$router.push("/error");
            this.msg = "无法获取当前设备详情";
        }
      });
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// login.vue?12b4a587